import React, {useEffect, useState} from 'react';
import { withStyles } from "@mui/styles";
import { Styles } from "../../../config/design/styles";
import {
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    List,
    ListItem,
    ListItemIcon, ListItemText,
    Typography
} from '@mui/material';
import {connect, getStore, setStore} from "trim-redux";
import {useTranslation} from "react-i18next";
import {CheckBoxRounded, Close} from "@mui/icons-material";
import Button from "@mui/material/Button";
import {useLocation, useNavigate} from "react-router-dom";
import AddressHolder from "./map/AddressHolder";
import AddressIcon from "./AddressIcon";
import GetConfirmationButton from "../elements/GetConfirmationButton";
import {Pencil, Plus, Trash, X, CircleCheck, DeleteIcon, TrashIcon} from "lucide-react";
import axios from "axios";
import {defaultVariables} from "../../../config";
import {updateRedux} from "../../../config/Security";
import {Alert} from "@mui/lab"; // Import useMediaQuery and Theme

function AddressChooserDialog({isAuth,open, setOpen,user,global_menu,new_location,address_dialog,has_alert = false }) {
    const { t } = useTranslation();
    const navigation = useNavigate();
    const [condition, setCondition] = useState("new");
    const [editing, setEditing] = useState(null);
    const [loading, setLoading] = useState(false);
    const [hasAlert, setHasAlert] = useState(has_alert);
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }


    useEffect(() => {
        setHasAlert(has_alert)
    }, [has_alert]);

    useEffect(() => {
        if (user.addresses.length > 0) {
            setCondition("multi")
        }
    }, [user.addresses]);

    useEffect(() => {
        if (new_location?.address) {
            setCondition("new")
        }
    }, [new_location]);

    const addAddress = () => {
        setCondition('new')
    }

    const closeDialog = () => {
        setOpen(false);
        setEditing(null);
        //navigation(`/${global_menu}`);
    }
    const handleClickAddress = (address_id) => {
        setLoading(true);
        axios.get(`${defaultVariables.url}/address/select/${address_id}/${user.id}`,config)
            .then(response => {
                handleAddressDone()
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false);
            });
    }
    const handleAddressDone = () => {
        updateRedux();
        closeDialog();
        setLoading(false);
        setEditing(false);

    }
    const handleDeleteAddress = (address_id) => {
        setLoading(true);
        const data = new FormData();
        data.append('address_id', address_id);
        axios.post(`${defaultVariables.url}/address/delete`,data,config)
            .then(response => {
                updateRedux();
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false);
            });
    }
    const handleEditAddress = (e,address_id) => {
        e.preventDefault();
        setEditing(address_id);
    }
    return (
        <>
            {
                !!isAuth &&
                <>
                    <Dialog maxWidth={(condition === "multi" && !editing) ? "sm" : "md"} fullWidth  open={open} onClose={() => closeDialog()}>
                        <DialogTitle className="dialog-title">
                            {t('address')}
                            {
                                !!loading && <CircularProgress size={18} style={{marginLeft:10}}/>
                            }
                            <IconButton
                                onClick={() => closeDialog()}
                                style={{position:"absolute",right:15,top:15}}
                                size="small"
                            >
                                <Close className="lucide-icon"/>
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            {
                                condition === "new" &&
                                <>
                                    {
                                        !!hasAlert &&
                                        <Typography style={{marginBottom:10}}>{t('addAddressToMakeOrder')}</Typography>
                                    }
                                    <AddressHolder handleAddressDone={() => handleAddressDone()} new_location={new_location}/>
                                </>
                            }
                            {
                                condition === "multi" &&
                                <>
                                    {
                                        !!editing ?
                                            <AddressHolder address_id={editing} handleAddressDone={() => handleAddressDone()}/>
                                            :
                                            <>
                                                <List>
                                                    {
                                                        user.addresses.map((address,index) => (
                                                            <div key={index} className="address-list-item-holder">
                                                                <ListItem
                                                                    alignItems="flex-start"

                                                                    button
                                                                    onClick={() => handleClickAddress(address.id)}
                                                                    className={address.is_selected ? "address-list-item active" : "address-list-item"}
                                                                    secondaryAction = {
                                                                        <>
                                                                            {
                                                                                !!address.is_selected &&
                                                                                <CircleCheck className="lucide-icon-secondary lucide-large"/>
                                                                            }
                                                                        </>
                                                                    }
                                                                >
                                                                    <ListItemIcon>
                                                                        <AddressIcon icon={address.icon}/>
                                                                    </ListItemIcon>
                                                                    <ListItemText
                                                                        primary={!!address.label ? address.label : t('address')}
                                                                        secondary={
                                                                            <React.Fragment>
                                                                                <Typography
                                                                                    component="span"
                                                                                    variant="body2"
                                                                                    sx={{ color: 'text.primary', display: 'inline' }}
                                                                                >
                                                                                    {address.manual_address}
                                                                                </Typography>
                                                                            </React.Fragment>
                                                                        }
                                                                    />

                                                                </ListItem>
                                                                <div className="actions">
                                                                    <IconButton onClick={(e) => handleEditAddress(e,address.id)}>
                                                                        <Pencil className="btn lucide-small-narrow"/>
                                                                    </IconButton>
                                                                    {
                                                                        !address.is_selected &&
                                                                        <GetConfirmationButton
                                                                            handleAction={() => handleDeleteAddress(address.id)}
                                                                            question={t('doYouWanaDeleteItem')}
                                                                            icon={<CheckBoxRounded/>}
                                                                            tooltip={t('delete')}
                                                                            iconColor="primary"
                                                                        >
                                                                            <TrashIcon className="btn lucide-small-narrow"/>
                                                                        </GetConfirmationButton>
                                                                    }

                                                                </div>
                                                            </div>

                                                        ))
                                                    }
                                                </List>
                                                <Button
                                                    onClick={() => addAddress()}
                                                    startIcon={<Plus/>}
                                                    variant="outlined"
                                                    color="default"
                                                >
                                                    {t('addNewAddress')}
                                                </Button>
                                            </>
                                    }
                                </>
                            }
                        </DialogContent>
                    </Dialog>
                </>
            }

        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    global_menu: state.global_menu,
    address_dialog:state.address_dialog
});

export default withStyles(Styles)(connect(mapStateToProps)(AddressChooserDialog));
